import { Injectable } from '@angular/core';
import { BaseService } from '@app/shared/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerCredit, AddCreditToWorkOrderInput } from '@app/core/models';

@Injectable({
  providedIn: 'root',
})
export class CustomerCreditService extends BaseService {
  constructor(protected http: HttpClient) {
    super('customer-credits', http);
  }

  getAllByCustomerId(id: number): Observable<CustomerCredit[]> {
    const params = new HttpParams().set('customerId', id);
    return this.http.get<CustomerCredit[]>(this.resourceUrl, { params });
  }

  addToWorkOrder(
    addCreditToWorkOrderInput: AddCreditToWorkOrderInput
  ): Observable<CustomerCredit> {
    return this.http.post<CustomerCredit>(
      `${this.resourceUrl}/${addCreditToWorkOrderInput.customerCreditId}/apply`,
      { workOrderId: addCreditToWorkOrderInput.workOrderId }
    );
  }
}
